import type { RelatedAudiencesQuery } from "src/graphql";

type Audience = RelatedAudiencesQuery["segments"][number];

/**
 * Merge the popover's debounced search results with the id-hydration results.
 *
 * Search rows win on id conflict — they are the freshest copy, while hydrated
 * rows live behind a longer staleTime.
 */
export const mergeRelatedAudiences = (
  searchResults: readonly Audience[] | undefined,
  hydrated: readonly Audience[] | undefined,
): Audience[] => {
  const search = searchResults ?? [];
  const searchIds = new Set(search.map((a) => String(a.id)));
  const extra = (hydrated ?? []).filter((a) => !searchIds.has(String(a.id)));
  return [...search, ...extra];
};
